module.exports = __webpack_public_path__ + "static/img/red.eb173d15.png";